(function () {
  "use strict";
  if (window.__auProductVideos) return;
  window.__auProductVideos = true;

  var hlsNative = function (video) {
    return !!video.canPlayType("application/vnd.apple.mpegurl");
  };

  var srcFor = function (tile, video) {
    var hls = tile.getAttribute("data-hls");
    return hls && hlsNative(video) && !window.MediaSource ? hls : tile.getAttribute("data-mp4") || hls;
  };

  var play = function (root, index) {
    var tiles = root.querySelectorAll("[data-au-video]");
    var dialog = root.querySelector("[data-au-video-dialog]");
    var video = dialog.querySelector("video");
    var i = (index + tiles.length) % tiles.length;
    root.__auIndex = i;
    var counter = dialog.querySelector("[data-au-video-index]");
    if (counter) counter.textContent = i + 1;
    video.setAttribute("data-loading", "");
    video.poster = tiles[i].getAttribute("data-poster") || "";
    video.src = srcFor(tiles[i], video);
    if (!dialog.open) dialog.showModal();
    video.muted = false;
    var p = video.play();
    if (p && p.catch) {
      p.catch(function (err) {
        if (err.name !== "NotAllowedError" || !dialog.open) return;
        video.muted = true;
        video.play().catch(function () {});
      });
    }
  };

  var stop = function (dialog) {
    var video = dialog.querySelector("video");
    video.pause();
    video.removeAttribute("src");
    video.load();
  };

  document.addEventListener("click", function (e) {
    var root = e.target.closest && e.target.closest("[data-au-videos]");
    if (!root) return;
    var dialog = root.querySelector("[data-au-video-dialog]");
    var tile = e.target.closest("[data-au-video]");
    if (tile) {
      play(root, Array.prototype.indexOf.call(root.querySelectorAll("[data-au-video]"), tile));
    } else if (e.target.closest("[data-au-video-next]")) {
      play(root, root.__auIndex + 1);
    } else if (e.target.closest("[data-au-video-prev]")) {
      play(root, root.__auIndex - 1);
    } else if (e.target.closest("[data-au-video-close]") || e.target === dialog) {
      dialog.close();
    }
  });

  document.addEventListener(
    "playing",
    function (e) {
      if (e.target.matches && e.target.matches(".au-videos__player")) e.target.removeAttribute("data-loading");
    },
    true
  );

  document.addEventListener("keydown", function (e) {
    var dialog = document.querySelector("[data-au-video-dialog][open]");
    if (!dialog || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var root = dialog.closest("[data-au-videos]");
    e.preventDefault();
    play(root, root.__auIndex + (e.key === "ArrowRight" ? 1 : -1));
  });

  var touch = null;
  document.addEventListener(
    "touchstart",
    function (e) {
      var dialog = e.target.closest && e.target.closest("[data-au-video-dialog][open]");
      touch = dialog && e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY, dialog: dialog } : null;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchend",
    function (e) {
      if (!touch || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - touch.x;
      var dy = e.changedTouches[0].clientY - touch.y;
      var dialog = touch.dialog;
      touch = null;
      var root = dialog.closest("[data-au-videos]");
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && root.querySelectorAll("[data-au-video]").length > 1) {
        play(root, root.__auIndex + (dx < 0 ? 1 : -1));
      } else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) {
        dialog.close();
      }
    },
    { passive: true }
  );

  document.addEventListener(
    "ended",
    function (e) {
      var root = e.target.closest && e.target.closest("[data-au-videos]");
      if (root && root.querySelectorAll("[data-au-video]").length > 1) play(root, root.__auIndex + 1);
    },
    true
  );

  document.addEventListener(
    "close",
    function (e) {
      if (e.target.matches && e.target.matches("[data-au-video-dialog]")) {
        stop(e.target);
        var tiles = e.target.closest("[data-au-videos]").querySelectorAll("[data-au-video]");
        var last = tiles[e.target.closest("[data-au-videos]").__auIndex];
        if (last) last.focus();
      }
    },
    true
  );
})();
